import { render, staticRenderFns } from "./Block_10.vue?vue&type=template&id=ba074ef8&scoped=true&"
import script from "./Block_10.vue?vue&type=script&lang=js&"
export * from "./Block_10.vue?vue&type=script&lang=js&"
import style0 from "./Block_10.vue?vue&type=style&index=0&id=ba074ef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba074ef8",
  null
  
)

export default component.exports